// extracted by mini-css-extract-plugin
export default {"common":"Menu_common__6g9fb","content":"Menu_content__fvBdl","h1":"Menu_h1__FNeoP","settingsCard":"Menu_settingsCard__Hoa+d"};